import type { PlatinumData } from '../types/carbon/models/PlatinumData'
import type { ChartType } from '../components/platinum-graphs/types'
import { extractColumnLabels, extractRowLabels } from '../components/platinum-graphs/utils/convertPlatinumData'

/**
 * Smart chart-type suggestion (#968 Part D). Reads the shape of the selected
 * table and proposes the type a researcher would usually reach for — always
 * overridable in the Chart Type dropdown, which stores an explicit value the
 * moment the user touches it.
 *
 * The heuristic is deliberately small:
 *   - several columns  → line (columns are almost always waves/periods here,
 *     and multi-wave data reads as a trend)
 *   - one column, few rows → pie (a single distribution)
 *   - one or two columns otherwise → bar (side-by-side comparison)
 *   - unknown shape → line, matching the creation default
 */
export function suggestChartType(data: PlatinumData | null | undefined): ChartType {
  if (!data) return 'line'
  const columns = extractColumnLabels(data).length
  const rows = extractRowLabels(data).length
  if (columns >= 4) return 'line'
  if (columns === 1) return rows > 0 && rows <= 6 ? 'pie' : 'bar'
  if (columns >= 2) return 'bar'
  return 'line'
}
